import { logger } from '@/utils/logger';
import Organization from '@/services/organization';
import User from '@/services/user';

const ns = 'app.models.user';

function getInitialState() {
  return {
    currentUser: null,
    organizations: undefined,
    workspaces: undefined,
    notifyLogout: null,
  };
}

const UserModel = {
  namespace: 'user',
  state: getInitialState(),
  effects: {
    *fetchCurrent(_, { call, put }) {
      const response = yield call(User.getCurrentAuthenticatedUser);
      yield put({
        type: 'saveCurrentUser',
        payload: response,
      });
    },

    *fetchWorkspaces(_, { call, put }) {
      const workspaces = yield call(Organization.getWorkspacesOfCurrentUser);
      logger.info({ label: `${ns}.fetchWorkspaces.workspaces`, message: workspaces });
      // Signed out: leave them unloaded, the session check is already on its way to the login page.
      if (workspaces === undefined) return;
      if (!workspaces) {
        yield put({ type: 'saveWorkspaces', payload: { organizations: null, workspaces: null } });
        return;
      }

      const organizations = workspaces.reduce((acc, current) => {
        const found = acc.findIndex((el) => el.id === current.organization.id);
        if (found < 0) acc.push(current.organization);
        return acc;
      }, []);
      logger.info({ label: `${ns}.fetchWorkspaces.organizations`, message: organizations });

      yield put({
        type: 'saveWorkspaces',
        payload: {
          organizations: organizations.sort((a, b) => a.name.localeCompare(b.name)),
          workspaces: workspaces.sort((a, b) => a.name.localeCompare(b.name)),
        },
      });
    },
    *notifyLogout({ payload }, { put }) {
      const { notifyLogout } = payload;
      yield put({
        type: 'saveNotifyLogout',
        payload: { notifyLogout },
      });
    },
    *updateUser({ payload }, { call }) {
      logger.debug({ label: 'app.models.user.updateUser', message: payload });
      yield call(User.updateUserDetails, payload);
    },
  },
  reducers: {
    resetAll(state) {
      return { ...getInitialState(), notifyLogout: state.notifyLogout }; // this is not ideal, perhaps notifyLogout should be in a separate redux state, such as for login_form
    },
    saveCurrentUser(state, { payload }) {
      return { ...state, currentUser: payload };
    },
    saveWorkspaces(state, { payload }) {
      return { ...state, organizations: payload.organizations, workspaces: payload.workspaces };
    },
    saveNotifyLogout(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default UserModel;
